export default function createRequestAnimationFramePromise() {
  return new Promise(requestAnimationFrame)
}
